// src/components/Agenda/DialogFichaPaciente.jsx
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import {
  FaUser,
  FaFileAlt,
  FaHeartbeat,
  FaTooth,
  FaCalendarCheck,
} from "react-icons/fa";

const DialogFichaPaciente = ({
  visible,
  onHide,
  fichaData,
  reservaEditando,
}) => {
  return (
    <Dialog
      visible={visible}
      style={{
        width: "90vw",
        maxWidth: "768px",
        fontFamily: "'Rajdhani', sans-serif",
      }}
      onHide={onHide}
      draggable={false}
      header={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "-25px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
              <FaCalendarCheck style={{ fontSize: "2.4rem", color: "#B83732" }} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <div
                style={{
                  fontSize: "0.9rem",
                  width: "100%",
                  letterSpacing: "1px",
                }}
              >
                FICHA DO
              </div>
              <div
                style={{
                  fontSize: "2rem",
                  fontWeight: "bold",
                  marginTop: "-10px",
                }}
              >
                PACIENTE
              </div>
            </div>
          </div>
        </div>
      }
    >
      {fichaData && reservaEditando && (
        <>
          <div style={{ padding: "10px 0" }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              {/* Informações do Paciente */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498db",
                    }}
                  >
                    <FaUser style={{ color: "#3498db", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Informações do Paciente
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                      fontSize: "0.9rem",
                      color: "#34495e",
                    }}
                  >
                    <div style={{ display: "flex", gap: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Nome:
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {reservaEditando.paciente_nome}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        CPF:
                      </span>
                      <span>{reservaEditando.paciente_cpf}</span>
                    </div>
                    <div style={{ display: "flex", gap: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Telefone:
                      </span>
                      <span>{reservaEditando.paciente_telefone}</span>
                    </div>
                    <div style={{ display: "flex", gap: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Email:
                      </span>
                      <span>{reservaEditando.paciente_email}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Observações e Plano de Tratamento */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #9b59b6",
                    }}
                  >
                    <FaFileAlt style={{ color: "#9b59b6", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Observações e Plano de Tratamento
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                      fontSize: "0.9rem",
                      color: "#34495e",
                    }}
                  >
                    <div style={{ display: "flex", gap: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Observações:
                      </span>
                    </div>
                    <div>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.observacoes || "Nenhuma observação cadastrada"}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: "5px", marginTop: "10px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Plano de Tratamento:
                      </span>
                    </div>
                    <div>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.plano_tratamento || "Nenhum plano cadastrado"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Anamnese */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "5px",
                marginBottom: "5px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2ecc71",
                    }}
                  >
                    <FaHeartbeat style={{ color: "#2ecc71", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      ANAMNESE - Histórico de Saúde
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                      fontSize: "0.9rem",
                      color: "#34495e",
                    }}
                  >
                    <div style={{ display: "flex", gap: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Tem problema de saúde?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.tem_problema_saude ? "Sim" : "Não"}
                      </span>
                    </div>
                    {fichaData.tem_problema_saude && fichaData.qual_problema_saude && (
                      <div style={{ marginLeft: "5px" }}>
                        <span>{fichaData.qual_problema_saude}</span>
                      </div>
                    )}
                    <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Está em tratamento médico?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.em_tratamento_medico ? "Sim" : "Não"}
                      </span>
                    </div>
                    {fichaData.em_tratamento_medico && fichaData.motivo_tratamento_medico && (
                      <div style={{ marginLeft: "5px" }}>
                        <span>{fichaData.motivo_tratamento_medico}</span>
                      </div>
                    )}
                    <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Usa medicamento?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.usa_medicamento ? "Sim" : "Não"}
                      </span>
                    </div>
                    {fichaData.usa_medicamento && fichaData.quais_medicamentos && (
                      <div style={{ marginLeft: "5px" }}>
                        <span>{fichaData.quais_medicamentos}</span>
                      </div>
                    )}
                    <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Tem alergia a medicamento?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.alergia_medicamento ? "Sim" : "Não"}
                      </span>
                    </div>
                    {fichaData.alergia_medicamento && fichaData.quais_alergias && (
                      <div style={{ marginLeft: "5px" }}>
                        <span>{fichaData.quais_alergias}</span>
                      </div>
                    )}
                    <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Pressão arterial:
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.pressao_arterial || "---"}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Fumante?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.fumante ? "Sim" : "Não"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Saúde Bucal */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaTooth style={{ color: "#E67E22", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Saúde Bucal e Hábitos
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                      fontSize: "0.9rem",
                      color: "#34495e",
                    }}
                  >
                    <div style={{ display: "flex", gap: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Gengivas sangram?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.gengiva_sangra ? "Sim" : "Não"}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Sensibilidade nos dentes?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.sensibilidade_dentes ? "Sim" : "Não"}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Escovações por dia?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.escovacoes_por_dia || "---"}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Usa fio dental?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.usa_fio_dental ? "Sim" : "Não"}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Frequência do fio dental?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.frequencia_fio_dental || "---"}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Rói unhas?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.roi_unhas ? "Sim" : "Não"}
                      </span>
                    </div>
                    <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                      <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                        Morde lápis/caneta?
                      </span>
                      <span style={{ fontWeight: "500" }}>
                        {fichaData.morde_lapis ? "Sim" : "Não"}
                      </span>
                    </div>
                    {fichaData.outros_habitos && (
                      <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
                        <span style={{ color: "#7f8c8d", fontSize: "0.8rem" }}>
                          Outros hábitos:
                        </span>
                        <span style={{ fontWeight: "500" }}>
                          {fichaData.outros_habitos}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="FECHAR"
              icon="pi pi-times"
              onClick={onHide}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "6px 20px",
                minWidth: "100px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
            />
          </div>
        </>
      )}
    </Dialog>
  );
};

export default DialogFichaPaciente;